import { snakeCase } from 'lodash';
import { StyledSelect } from '~/components/dropdowns/select.style';

export type LmiProofDocTypeSelectOptions = {
  disabled?: boolean;
  selected?: boolean;
  text: string;
  value?: number | string;
};

export const LMIProofDocTypeSelect = ({
  allDocumentTypes = [],
  addedDocumentTypes,
  selectedDocumentType,
  disabled,
  required,
  onChange,
  label,
}: LMIProofDocTypeSelectProps) => {
  // eslint-disable-next-line camelcase
  const __EXPERIMENTAL_getOptions = () => {
    if (Array.isArray(allDocumentTypes)) {
      return allDocumentTypes
        .filter(
          documentType =>
            documentType === selectedDocumentType || !addedDocumentTypes.includes(documentType),
        )
        .map(documentType => ({
          text: documentType,
          value: snakeCase(documentType),
        }));
    } else {
      return Object.entries(allDocumentTypes)
        .filter(([key]) => key === selectedDocumentType || !addedDocumentTypes.includes(key))
        .map(([key, value]) => ({
          text: value,
          value: key,
        }));
    }
  };

  return (
    <StyledSelect
      required={required}
      minHeight="0px"
      disabled={disabled}
      label={label}
      name={label}
      withEmptyPlaceholder={!selectedDocumentType}
      onChange={onChange}
      options={__EXPERIMENTAL_getOptions()}
      value={selectedDocumentType ?? ''}
    />
  );
};

export interface LMIProofDocTypeSelectProps {
  allDocumentTypes: string[] | Record<string, string>;
  addedDocumentTypes: string[];
  selectedDocumentType?: string;
  disabled?: boolean;
  required?: boolean;
  onChange: (newDocumentType: string) => void;
  label: string;
}
